(function() {
  'use strict';

  var CONFIG = window.MHV_DISPLAY_CONFIG || {};
  var SERVER = CONFIG.serverUrl || 'https://mhv-viewer-app-1df0c0c61ed9.herokuapp.com';
  var STORAGE_KEY = 'mhv_display_code';
  var socket = null;
  var myCode = null;

  // =========================================================================
  // WAKE LOCK — keep screen on
  // =========================================================================
  var wakeLock = null;
  async function requestWakeLock() {
    if (!('wakeLock' in navigator)) return;
    try {
      wakeLock = await navigator.wakeLock.request('screen');
      wakeLock.addEventListener('release', function() { wakeLock = null; });
    } catch (e) {}
  }
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && !wakeLock) requestWakeLock();
  });
  requestWakeLock();

  // =========================================================================
  // SCREENS
  // =========================================================================
  function showScreen(name) {
    var screens = document.querySelectorAll('.cd-screen');
    for (var i = 0; i < screens.length; i++) screens[i].style.display = 'none';
    var el = document.getElementById('cd-' + name + '-screen');
    if (el) el.style.display = '';
    // Fullscreen toggle stays visible only on pair/idle (out-of-flow screens).
    var fsBtn = document.getElementById('cd-fullscreen-btn');
    if (fsBtn) fsBtn.style.display = (name === 'pair' || name === 'idle') ? '' : 'none';
  }

  function fmt(n) {
    return '$' + (parseFloat(n) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  // =========================================================================
  // SOCKET + ROOM CREATION
  // =========================================================================
  function initSocket(code) {
    socket = io(SERVER, { transports: ['websocket', 'polling'] });

    socket.on('connect', function() {
      socket.emit('display-tablet-create', { code: code }, function(r) {
        if (!r || !r.ok) return;
        myCode = r.code;
        try { localStorage.setItem(STORAGE_KEY, myCode); } catch (e) {}
        var codeEl = document.getElementById('cd-pair-code');
        if (codeEl) codeEl.textContent = myCode;
        // If admin is already connected, go straight to idle
        if (r.adminConnected) showScreen('idle');
      });
    });

    socket.on('display-order', renderOrder);
    socket.on('display-customer', renderCustomer);
    socket.on('display-clear', function() { clearAndIdle(); });

    socket.on('display-admin-connected', function() {
      var statusEl = document.getElementById('cd-idle-status');
      if (statusEl) statusEl.textContent = 'Connected';
      showScreen('idle');
    });

    socket.on('display-admin-disconnected', function() {
      // Admin disconnected — stay on idle, they'll rejoin
    });

    socket.io.on('reconnect', function() {
      if (myCode) {
        socket.emit('display-tablet-create', { code: myCode }, function(r) {
          if (!r || !r.ok) {
            myCode = null;
            try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
            showScreen('pair');
          }
        });
      }
    });
  }

  // =========================================================================
  // 5-TAP UNLINK
  // =========================================================================
  var unlinkTaps = 0;
  var unlinkTimer = null;

  function handleUnlinkTap() {
    unlinkTaps++;
    clearTimeout(unlinkTimer);
    unlinkTimer = setTimeout(function() { unlinkTaps = 0; }, 1500);
    if (unlinkTaps >= 5) {
      unlinkTaps = 0;
      if (socket && myCode) {
        socket.emit('display-tablet-unpair', { code: myCode });
      }
      myCode = null;
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      showScreen('pair');
      // Generate a new code
      createNewCode();
    }
  }

  function createNewCode() {
    if (!socket || !socket.connected) {
      initSocket('');
      return;
    }
    socket.emit('display-tablet-create', {}, function(r) {
      if (!r || !r.ok) return;
      myCode = r.code;
      try { localStorage.setItem(STORAGE_KEY, myCode); } catch (e) {}
      var codeEl = document.getElementById('cd-pair-code');
      if (codeEl) codeEl.textContent = myCode;
    });
  }

  // =========================================================================
  // AUTO-CLEAR — privacy safeguard if staff walks away mid-modal
  // =========================================================================
  var IDLE_TIMEOUT_MS = 2 * 60 * 1000;
  var idleTimer = null;
  function resetIdleTimer() {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(clearAndIdle, IDLE_TIMEOUT_MS);
  }
  function cancelIdleTimer() {
    if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
  }
  function clearAndIdle() {
    cancelIdleTimer();
    if (typeof clearTransients === 'function') clearTransients();
    activeCustomer = null;
    showScreen('idle');
  }

  // =========================================================================
  // CUSTOMER DETAIL RENDERING (display-customer event)
  //
  // modes:
  //   'customer'  — paired customer self-verification view (read-only contact + marketing buttons)
  //   'pending'   — partial info pushed during new-bidder form entry (no marketing buttons)
  //   'welcome'   — 3s welcome flash on customer create
  //   'paddle'    — 5s paddle assignment flash, then thanks-clear
  //   'thanks'    — 3s thanks-for-confirming on close, then idle
  // =========================================================================
  var activeCustomer = null; // last customer payload — used for re-render on marketing change

  function maskEmail(email) {
    if (!email) return '';
    var at = email.indexOf('@');
    if (at < 0) return email;
    var local = email.substring(0, at);
    var host = email.substring(at);
    if (local.length <= 2) return email; // not worth masking
    var stars = '<span class="cd-mask">' + new Array(Math.max(local.length - 2, 6) + 1).join('*') + '</span>';
    return esc(local.charAt(0)) + stars + esc(local.charAt(local.length - 1)) + esc(host);
  }
  function maskPhone(phone) {
    if (!phone) return '';
    var digits = String(phone).replace(/\D/g, '');
    if (digits.length < 4) return phone;
    var last4 = digits.slice(-4);
    var stars = '<span class="cd-mask">***</span>';
    return stars + ' &ndash; ' + stars + ' &ndash; ' + esc(last4);
  }
  function formatAddress(c) {
    if (!c.address1) return '';
    var line2parts = [];
    if (c.city) line2parts.push(c.city);
    var stateZip = [c.province, c.zip].filter(Boolean).join(' ');
    if (stateZip) line2parts.push(stateZip);
    return c.address1 + '\n' + line2parts.join(', ');
  }
  function marketingStatusLabel(state) {
    if (state === 'subscribed') return 'Subscribed';
    if (state === 'unsubscribed') return 'Unsubscribed';
    return 'Not subscribed';
  }
  function renderMarketingRow(channel, state, container) {
    if (!container) return;
    var label = channel === 'email' ? 'Email updates' : 'Text reminders';
    var html = '<span class="cd-marketing-label">' + label + ':</span>';
    html += '<span class="cd-marketing-status cd-marketing-status--' + esc(state) + '">' + marketingStatusLabel(state) + '</span>';
    if (state === 'subscribed') {
      html += '<button class="cd-unsub-btn" data-channel="' + channel + '" data-action="opt_out">Unsubscribe</button>';
    } else {
      html += '<button class="cd-subscribe-btn" data-channel="' + channel + '" data-action="opt_in">Subscribe</button>';
    }
    container.innerHTML = html;
    var btns = container.querySelectorAll('button[data-channel]');
    for (var i = 0; i < btns.length; i++) btns[i].addEventListener('click', onMarketingBtnClick);
  }

  // Pending transient-screen timers (paddle → thanks → idle, etc). Cleared on every
  // new event so a late-firing setTimeout from a previous screen can't override the
  // current one.
  var transientTimers = [];
  function setTransient(fn, ms) { var t = setTimeout(fn, ms); transientTimers.push(t); return t; }
  function clearTransients() { while (transientTimers.length) clearTimeout(transientTimers.pop()); }

  function renderCustomer(data) {
    if (!data) return;
    var mode = data.mode || 'customer';
    cancelIdleTimer();
    clearTransients();

    if (mode === 'welcome') {
      showScreen('welcome');
      // Welcome holds for ~3s, then admin sends the customer payload as a second event.
      return;
    }
    if (mode === 'paddle') {
      var numEl = document.getElementById('cd-paddle-number');
      var nameEl = document.getElementById('cd-paddle-name');
      if (numEl) numEl.textContent = data.paddleNumber != null ? String(data.paddleNumber) : '';
      if (nameEl) nameEl.textContent = data.customerName || '';
      showScreen('paddle');
      // Auto-fade to thanks then idle. Admin can override by sending another event.
      setTransient(function() { showScreen('thanks'); }, 5000);
      setTransient(clearAndIdle, 8000);
      return;
    }
    if (mode === 'thanks') {
      showScreen('thanks');
      setTransient(clearAndIdle, 3000);
      return;
    }

    activeCustomer = data;
    showScreen('customer');
    resetIdleTimer();

    // Reset the confirm button to its default state for the new customer
    var cBtn = document.getElementById('cd-confirm-btn');
    if (cBtn) { cBtn.disabled = false; cBtn.textContent = 'Yes, everything looks good'; }

    var firstName = (data.firstName || '').trim();
    var lastName = (data.lastName || '').trim();
    var full = (firstName + ' ' + lastName).trim() || 'Customer';

    var greetEl = document.getElementById('cd-customer-greeting');
    if (greetEl) greetEl.textContent = firstName ? ('Hi, ' + firstName) : 'Hi there';

    var nameEl = document.getElementById('cd-customer-fullname');
    if (nameEl) nameEl.textContent = full;

    var emailEl = document.getElementById('cd-info-email');
    if (emailEl) {
      // Pending mode (typing in new-bidder form): show unmasked so customer can verify spelling
      if (mode === 'pending') emailEl.textContent = data.email || '(no email yet)';
      else emailEl.innerHTML = data.email ? maskEmail(data.email) : '<span style="color:var(--mhv-text-muted)">No email on file</span>';
    }
    var phoneEl = document.getElementById('cd-info-phone');
    if (phoneEl) {
      if (mode === 'pending') phoneEl.textContent = data.phone || '(no phone yet)';
      else phoneEl.innerHTML = data.phone ? maskPhone(data.phone) : '<span style="color:var(--mhv-text-muted)">No phone on file</span>';
    }
    var addrEl = document.getElementById('cd-info-address');
    if (addrEl) {
      var addr = formatAddress(data);
      addrEl.textContent = addr || 'No address on file';
      if (!addr) addrEl.style.color = 'var(--mhv-text-muted)';
      else addrEl.style.color = '';
    }

    // Marketing rows — only in 'customer' mode (not pending, where we have no customer_id yet)
    var emailRow = document.getElementById('cd-email-marketing-row');
    var smsRow = document.getElementById('cd-sms-marketing-row');
    if (mode === 'customer') {
      renderMarketingRow('email', data.email_marketing_state || 'not_subscribed', emailRow);
      renderMarketingRow('sms', data.sms_marketing_state || 'not_subscribed', smsRow);
    } else {
      if (emailRow) emailRow.innerHTML = '&nbsp;';
      if (smsRow) smsRow.innerHTML = '&nbsp;';
    }
  }

  // Marketing button click → for SMS, show TCPA disclosure first; for email, fire-and-forget.
  function onMarketingBtnClick() {
    var channel = this.getAttribute('data-channel');
    var action = this.getAttribute('data-action');
    if (channel === 'sms' && action === 'opt_in') {
      showDisclosureModal(channel, function(agreed) {
        if (agreed) emitMarketingAction(channel, action);
      });
      return;
    }
    // Email opt-in/out and SMS opt-out — no extra disclosure step
    emitMarketingAction(channel, action);
  }

  function emitMarketingAction(channel, action) {
    if (!socket || !myCode) return;
    socket.emit('display-customer-action', {
      code: myCode,
      type: 'marketing',
      channel: channel,
      action: action,
      customerId: activeCustomer ? activeCustomer.customerId : null
    });
    // Optimistic UI: flip the local row immediately so the customer sees feedback.
    if (activeCustomer) {
      var key = channel === 'email' ? 'email_marketing_state' : 'sms_marketing_state';
      activeCustomer[key] = action === 'opt_in' ? 'subscribed' : 'unsubscribed';
      var rowId = channel === 'email' ? 'cd-email-marketing-row' : 'cd-sms-marketing-row';
      renderMarketingRow(channel, activeCustomer[key], document.getElementById(rowId));
    }
    resetIdleTimer();
  }

  // TCPA disclosure modal — must be shown before SMS opt-in to capture written consent
  var SMS_DISCLOSURE_HTML = '<p>By tapping <strong>I agree</strong>, you consent to receive recurring marketing text messages (auction reminders, featured lots, event news) from <strong>Granite Union Auction Company</strong> at the phone number on file.</p>' +
    '<p>Message and data rates may apply. Message frequency varies. Text <strong>STOP</strong> to opt out at any time. Text <strong>HELP</strong> for help.</p>' +
    '<p>See our <a href="https://graniteunionauction.com/policies/privacy-policy" target="_blank">Privacy Policy</a> and <a href="https://graniteunionauction.com/policies/terms-of-service" target="_blank">Terms of Service</a>. Your consent is not required as a condition of any purchase.</p>';

  function showDisclosureModal(channel, callback) {
    var overlay = document.getElementById('cd-disclosure-overlay');
    var title = document.getElementById('cd-disclosure-title');
    var body = document.getElementById('cd-disclosure-body');
    var confirmBtn = document.getElementById('cd-disclosure-confirm');
    var cancelBtn = document.getElementById('cd-disclosure-cancel');
    if (!overlay) return callback(true); // fallback — proceed if modal missing

    if (title) title.textContent = 'Subscribe to text messages';
    if (body) body.innerHTML = SMS_DISCLOSURE_HTML;
    overlay.style.display = 'flex';

    function cleanup() {
      overlay.style.display = 'none';
      confirmBtn.removeEventListener('click', onYes);
      cancelBtn.removeEventListener('click', onNo);
      overlay.removeEventListener('click', onBg);
    }
    function onYes() { cleanup(); callback(true); }
    function onNo() { cleanup(); callback(false); }
    function onBg(e) { if (e.target === overlay) onNo(); }
    confirmBtn.addEventListener('click', onYes);
    cancelBtn.addEventListener('click', onNo);
    overlay.addEventListener('click', onBg);
    resetIdleTimer();
  }

  // "Yes, everything looks good" button on the customer detail view
  var confirmBtn = document.getElementById('cd-confirm-btn');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', function() {
      if (!socket || !myCode) return;
      socket.emit('display-customer-action', {
        code: myCode,
        type: 'confirm',
        customerId: activeCustomer ? activeCustomer.customerId : null
      });
      // Brief visual confirmation
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Thank you!';
      resetIdleTimer();
    });
  }

  // =========================================================================
  // ORDER RENDERING
  // =========================================================================
  function renderOrder(data) {
    if (!data || !data.items) return;
    cancelIdleTimer(); // active checkout — don't auto-clear
    showScreen('order');

    var nameEl = document.getElementById('cd-customer-name');
    if (nameEl) nameEl.textContent = data.customerName || 'Customer';

    var idEl = document.getElementById('cd-customer-id');
    if (idEl) {
      var parts = [];
      if (data.paddleNumber) parts.push('Paddle #' + esc(data.paddleNumber));
      if (data.bidderNumber) parts.push('Bidder #' + esc(data.bidderNumber));
      idEl.innerHTML = parts.join(' / ') || '';
    }

    var listEl = document.getElementById('cd-items-list');
    if (listEl) {
      var html = '';
      for (var i = 0; i < data.items.length; i++) {
        var item = data.items[i];
        html += '<div class="cd-item">';
        var imgSrc = item.imageUrl || 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/no-image-placeholder.png?v=1756872687';
        // Request 2x resolution for sharp display on retina/tablet screens
        if (imgSrc.indexOf('cdn.shopify.com') >= 0 && imgSrc.indexOf('_') === -1) {
          imgSrc = imgSrc.replace(/\.(\w+)(\?|$)/, '_200x200.$1$2');
        }
        html += '<img class="cd-item-img" src="' + esc(imgSrc) + '" alt="">';
        html += '<div class="cd-item-info">';
        html += '<div class="cd-item-title">' + esc(item.title) + '</div>';
        if (item.lotNumber) html += '<div class="cd-item-lot">Lot #' + esc(item.lotNumber) + '</div>';
        html += '</div>';
        html += '<div class="cd-item-price">' + fmt(item.salePrice) + '</div>';
        html += '</div>';
      }
      listEl.innerHTML = html;
    }

    var subEl = document.getElementById('cd-subtotal');
    var bpPctEl = document.getElementById('cd-bp-pct');
    var bpAmtEl = document.getElementById('cd-bp-amount');
    var grandEl = document.getElementById('cd-grand-total');
    if (subEl) subEl.textContent = fmt(data.subtotal || 0);
    if (bpPctEl) bpPctEl.textContent = data.bpPercent || 0;
    if (bpAmtEl) bpAmtEl.textContent = fmt(data.bpAmount || 0);
    if (grandEl) grandEl.textContent = fmt(data.total || 0);
  }

  // =========================================================================
  // INIT
  // =========================================================================
  var idleStatus = document.getElementById('cd-idle-status');
  if (idleStatus) idleStatus.addEventListener('click', handleUnlinkTap);

  // Fullscreen — single tap to enter, 5-tap to exit
  var fsTaps = 0;
  var fsTimer = null;
  var fsBtn = document.getElementById('cd-fullscreen-btn');
  if (fsBtn) {
    fsBtn.addEventListener('click', function() {
      var doc = document.documentElement;
      if (document.fullscreenElement) {
        fsTaps++;
        clearTimeout(fsTimer);
        fsTimer = setTimeout(function() { fsTaps = 0; }, 1500);
        if (fsTaps >= 5) {
          fsTaps = 0;
          document.exitFullscreen().catch(function() {});
        }
      } else {
        (doc.requestFullscreen || doc.webkitRequestFullscreen || doc.msRequestFullscreen).call(doc).catch(function() {});
      }
    });
  }

  // Load saved code or generate new one
  var savedCode = null;
  try { savedCode = localStorage.getItem(STORAGE_KEY); } catch (e) {}

  // Always show pair screen first with the code
  showScreen('pair');
  initSocket(savedCode || '');

})();
